<template>
  <div class="card">
    <div class="card-gallery">
      <Swiper
        class="card-gallery__slider h-full w-full"
        :modules="[Navigation, Pagination, Mousewheel]"
        :navigation="{
          prevEl: '.card-gallery__navigation-button--prev',
          nextEl: '.card-gallery__navigation-button--next',
          disabledClass: 'disabled'
        }"
        :pagination="{ el: '.card-gallery__pagination', clickable: true }"
        :mousewheel="{ forceToAxis: true }"
      >
        <SwiperSlide v-for="(image, index) in images" :key="index" class="select-none">
          <ElementsImage v-bind="image.formats?.medium" loading="lazy" />
        </SwiperSlide>

        <div class="card-gallery__navigation">
          <button class="card-gallery__navigation-button card-gallery__navigation-button--prev" aria-label="Prev Slider" data-prev>
            <svg viewBox="0 0 28 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.19879 4.51162C0.0715008 4.63895 -5.72205e-06 4.81162 -5.72205e-06 4.99166C-5.72205e-06 5.1717 0.0715008 5.34437 0.19879 5.47169L4.51981 9.79272C4.58245 9.85757 4.65737 9.90929 4.7402 9.94488C4.82304 9.98046 4.91214 9.99919 5.00229 9.99997C5.09245 10.0008 5.18186 9.98358 5.2653 9.94944C5.34874 9.9153 5.42455 9.86488 5.4883 9.80113C5.55205 9.73738 5.60247 9.66157 5.63661 9.57813C5.67075 9.49468 5.68793 9.40528 5.68715 9.31512C5.68636 9.22497 5.66763 9.13587 5.63205 9.05303C5.59646 8.9702 5.54474 8.89527 5.47989 8.83264L1.6389 4.99166L5.47989 1.15067C5.60357 1.02262 5.672 0.851105 5.67046 0.673079C5.66891 0.495053 5.59751 0.324757 5.47162 0.198868C5.34573 0.0729799 5.17543 0.00157261 4.99741 2.57492e-05C4.81938 -0.00152111 4.64787 0.0669155 4.51981 0.190598L0.19879 4.51162ZM27.838 4.31268H0.678827V5.67064H27.838V4.31268Z"
                fill="currentColor"
              ></path>
            </svg>
          </button>
          <button class="card-gallery__navigation-button card-gallery__navigation-button--next" aria-label="Next Slider" data-next>
            <svg viewBox="0 0 28 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M27.8012 5.48838C27.9285 5.36105 28 5.18838 28 5.00834C28 4.8283 27.9285 4.65563 27.8012 4.52831L23.4802 0.207284C23.4175 0.142435 23.3426 0.0907087 23.2598 0.0551241C23.1769 0.0195395 23.0878 0.000809053 22.9977 2.56361e-05C22.9075 -0.000757781 22.8181 0.0164215 22.7347 0.0505612C22.6512 0.0847008 22.5754 0.135117 22.5117 0.198868C22.4479 0.262619 22.3975 0.338429 22.3634 0.421873C22.3292 0.505317 22.312 0.594724 22.3128 0.684879C22.3136 0.775033 22.3323 0.864129 22.3679 0.946967C22.4035 1.0298 22.4552 1.10473 22.5201 1.16736L26.3611 5.00834L22.5201 8.84933C22.3964 8.97738 22.328 9.1489 22.3295 9.32692C22.3311 9.50495 22.4025 9.67524 22.5284 9.80113C22.6542 9.92702 22.8245 9.99843 23.0026 9.99997C23.1806 10.0015 23.3521 9.93308 23.4802 9.8094L27.8012 5.48838ZM0.161987 5.68732H27.3211V4.32936H0.161987V5.68732Z"
                fill="currentColor"
              ></path>
            </svg>
          </button>
        </div>
        <div class="card-gallery__pagination"></div>
      </Swiper>
    </div>

    <NuxtLinkLocale :to="`/rooms/${slug}`" class="card-heading">
      <span class="card-heading__title">{{ name }}</span>
      <span class="card-heading__size">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M16.0007 0.468686C16.0007 0.344383 15.9513 0.225171 15.8634 0.137275C15.7755 0.0493793 15.6563 0 15.532 0H0.468686C0.407137 0 0.346191 0.0121229 0.289328 0.0356766C0.232464 0.0592303 0.180797 0.0937535 0.137275 0.137275C0.0493793 0.225171 0 0.344383 0 0.468686V15.5313C0 15.79 0.210009 16 0.468686 16H13.1879C13.3122 16 13.4314 15.9506 13.5193 15.8627C13.6072 15.7748 13.6566 15.6556 13.6566 15.5313V14.1573C13.6566 14.033 13.6072 13.9137 13.5193 13.8258C13.4314 13.7379 13.3122 13.6886 13.1879 13.6886C13.0636 13.6886 12.9444 13.7379 12.8565 13.8258C12.7686 13.9137 12.7192 14.033 12.7192 14.1573V15.0626H0.937372V12.2245H5.6569C5.78121 12.2245 5.90042 12.1751 5.98831 12.0872C6.07621 11.9993 6.12559 11.8801 6.12559 11.7558C6.12559 11.6315 6.07621 11.5123 5.98831 11.4244C5.90042 11.3365 5.78121 11.2871 5.6569 11.2871H0.937372V0.938039H8.37368V5.5629C8.37368 5.6872 8.42306 5.80641 8.51096 5.89431C8.59885 5.98221 8.71807 6.03158 8.84237 6.03158C8.96667 6.03158 9.08588 5.98221 9.17378 5.89431C9.26168 5.80641 9.31105 5.6872 9.31105 5.5629V0.938039H15.0633V9.5004H9.37572V8.37568C9.37572 8.25129 9.32631 8.13199 9.23835 8.04404C9.15039 7.95608 9.0311 7.90666 8.9067 7.90666C8.78231 7.90666 8.66302 7.95608 8.57506 8.04404C8.4871 8.13199 8.43768 8.25129 8.43768 8.37568V9.96908C8.43768 10.2278 8.64769 10.4378 8.90704 10.4378H12.7812V11.3438C12.7812 11.4682 12.8306 11.5875 12.9186 11.6755C13.0065 11.7634 13.1258 11.8128 13.2502 11.8128C13.3746 11.8128 13.4939 11.7634 13.5819 11.6755C13.6698 11.5875 13.7192 11.4682 13.7192 11.3438V10.4378H15.532C15.6563 10.4378 15.7755 10.3884 15.8634 10.3005C15.9513 10.2126 16.0007 10.0934 16.0007 9.96908V0.468686Z"
            fill="currentColor"
          />
        </svg>
        <span>{{ msquare }} m² oda büyüklüğü</span>
      </span>
    </NuxtLinkLocale>

    <div class="card-features">
      <div v-for="(feature, index) in features" :key="index" class="card-features__item">
        <div class="card-features__item-icon">
          <Icon :name="`sivene:${feature.icon}`" v-if="feature.icon" />
        </div>
        <div class="card-features__item-title" v-html="feature.name?.replaceAll('\\n', '<br>')"></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { Swiper, SwiperSlide } from "swiper/vue"
  import { Navigation, Pagination, Mousewheel } from "swiper/modules"
  import "swiper/css"
  import "swiper/css/navigation"
  import "swiper/css/pagination"

  defineProps<{
    name?: string
    slug?: string
    images?: any[]
    msquare?: string | number
    person_count?: string | number
    features?: { icon: string; name: string }[]
  }>()
</script>

<style lang="scss" scoped>
  .card {
    @apply flex flex-col gap-6;

    &-gallery {
      @apply w-full relative bg-black/2;
      padding-top: 56.25%;

      &__slider {
        @apply absolute w-full h-full inset-0 z-0;

        :deep(img) {
          @apply object-cover w-full h-full;
        }
      }
      &__navigation {
        @apply absolute items-center inset-0 w-full h-full px-8 flex justify-between z-20 pointer-events-none;

        &-button {
          @apply flex pointer-events-auto h-fit p-2 -m-2 text-white bg-transparent border-none outline-none;

          svg {
            @apply h-2.5 w-auto;
          }
          &.disabled {
            @apply opacity-70;
          }
        }
      }
      &__pagination {
        --swiper-pagination-bullet-width: 24px;
        --swiper-pagination-color: white;
        --swiper-pagination-bullet-border-radius: 0;
        --swiper-pagination-bullet-height: 2px;
        --swiper-pagination-bullet-horizontal-gap: 2px;
        --swiper-pagination-bullet-inactive-color: white;
        --swiper-pagination-bullet-inactive-opacity: 0.4;

        @apply absolute bottom-4 left-0 right-0 flex justify-center z-20;
      }

      &::after {
        @apply absolute z-10 inset-0 w-full h-full pointer-events-none;
        content: "";
        background: linear-gradient(0deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 30%);
      }
    }
    &-heading {
      @apply flex flex-col text-center justify-center items-center gap-1.5;

      &__title {
        color: #000;
        font-size: 26px;
        font-weight: 500;
        line-height: 32px;
        letter-spacing: 2.08px;
        text-transform: uppercase;
      }
      &__size {
        @apply flex items-center gap-2.5;
        color: #282828;
        font-size: 16px;
        line-height: 24px;
      }
    }
    &-features {
      @apply flex justify-center flex-wrap gap-x-6 gap-y-6;

      &__item {
        @apply flex flex-col justify-center items-center text-center w-23 gap-2.5;
        color: #282828;

        &-icon {
          font-size: 56px;
        }
        &-title {
          @apply text-balance;
          font-size: 12px;
          font-weight: 400;
          line-height: 15px;
          letter-spacing: 0.36px;
        }
      }
    }

    @include media("lg") {
      &-features {
        @apply gap-4;

        &__item {
          @apply w-auto min-w-16;

          &-icon {
            font-size: 48px;
          }
          &-title {
            letter-spacing: 0.25px;
          }
        }
      }
    }
    @include media("md") {
      @apply gap-4;

      &-gallery {
        &__navigation {
          @apply px-4;
        }
        &__pagination {
          --swiper-pagination-bullet-width: 16px;

          @apply bottom-3;
        }
      }
      &-heading {
        &__title {
          font-size: 20px;
          line-height: 26px;
          letter-spacing: 1px;
        }
        &__size {
          @apply gap-2;
          font-size: 14px;
          line-height: 18px;

          svg {
            @apply h-3.5 w-auto;
          }
        }
      }
      &-features {
        @apply gap-3;

        &__item {
          @apply min-w-14 gap-2;

          &-icon {
            font-size: 44px;
          }
          &-title {
            font-size: 11px;
            line-height: 15px;
          }
        }
      }
    }
  }
</style>
